import html2pdf from 'html2pdf.js';

function syncRadioGroups(original, clone) {
  const groups = new Map();
  const originalRadios = original.querySelectorAll('input[type="radio"]');

  // Collect selected value per group from original
  originalRadios.forEach(radio => {
    const name = radio.name;
    if (!groups.has(name)) groups.set(name, { selected: null });
    if (radio.checked) groups.get(name).selected = radio.value;
  });

  // Apply to clone
  const cloneRadios = clone.querySelectorAll('input[type="radio"]');
  cloneRadios.forEach(radio => {
    const group = groups.get(radio.name);
    if (group && group.selected === radio.value) {
      radio.checked = true;
    } else {
      radio.checked = false;
    }
  });
}

/**
 * Copy value from original text/textarea/select to clone.
 * Works even if element counts differ – matches by comparable path.
 */
function syncFormValues(original, clone) {
  // Sync text inputs, textareas, selects
  const originalInputs = original.querySelectorAll('input:not([type="radio"]):not([type="checkbox"]), textarea, select');
  const cloneInputs = clone.querySelectorAll('input:not([type="radio"]):not([type="checkbox"]), textarea, select');

  for (let i = 0; i < originalInputs.length; i++) {
    if (cloneInputs[i]) {
      cloneInputs[i].value = originalInputs[i].value;
    }
  }

  // Sync radio groups separately (more reliable)
  syncRadioGroups(original, clone);
}

function replaceRadiosWithText(container) {
  const groups = new Map();
  const radios = container.querySelectorAll('input[type="radio"]');

  radios.forEach(radio => {
    const name = radio.name;
    if (!groups.has(name)) groups.set(name, { selected: null, elements: [] });
    const group = groups.get(name);
    group.elements.push(radio);
    if (radio.checked) group.selected = radio.value;
  });

  groups.forEach((group) => {
    if (group.elements.length === 0) return;
    const parentCell = group.elements[0].closest('td');
    if (parentCell) {
      const selectedText = group.selected || 'Not selected';
      const span = document.createElement('span');
      span.textContent = selectedText;
      parentCell.innerHTML = '';
      parentCell.appendChild(span);
    }
  });
}

function replaceInputsWithText(container) {
  const textareas = container.querySelectorAll('textarea');
  textareas.forEach(ta => {
    const span = document.createElement('span');
    span.textContent = ta.value || '-';
    span.style.whiteSpace = 'pre-wrap';
    ta.parentNode.replaceChild(span, ta);
  });

  const textInputs = container.querySelectorAll('input[type="text"], input[readonly]');
  textInputs.forEach(inp => {
    const span = document.createElement('span');
    span.textContent = inp.value || '-';
    inp.parentNode.replaceChild(span, inp);
  });

  const selects = container.querySelectorAll('select');
  selects.forEach(sel => {
    const selectedText = sel.options[sel.selectedIndex]?.text || '-';
    const span = document.createElement('span');
    span.textContent = selectedText;
    sel.parentNode.replaceChild(span, sel);
  });
}

function makeTablesResponsive(container) {
  const style = document.createElement('style');
  style.textContent = `
    table { width: 100% !important; table-layout: auto !important; word-break: break-word !important; font-size: 10pt !important; }
    td, th { padding: 4px !important; word-break: break-word !important; }
    .table-bordered { border-collapse: collapse !important; }
    @media print { body { margin: 0; padding: 0; } table { page-break-inside: avoid; } tr { page-break-inside: avoid; } }
  `;
  container.prepend(style);
}

export const generateDataOnlyPDF = (element, filename = 'report.pdf', onStart = null, onComplete = null) => {
  if (!element) {
    console.error('No element provided');
    return;
  }
  if (onStart) onStart();

  const clone = element.cloneNode(true);

  // ✅ Copy all current values and checked states
  syncFormValues(element, clone);

  // Replace with static text
  replaceRadiosWithText(clone);
  replaceInputsWithText(clone);
  makeTablesResponsive(clone);

  // Remove buttons
  clone.querySelectorAll('button').forEach(btn => btn.remove());

  const options = {
    margin: [0.5, 0.5, 0.5, 0.5],
    filename: filename,
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: { scale: 2, useCORS: true, logging: false },
    jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
  };

  html2pdf()
    .set(options)
    .from(clone)
    .save()
    .then(() => onComplete && onComplete())
    .catch(error => {
      console.error(error);
      onComplete && onComplete();
    });
};

export const downloadPDF = generateDataOnlyPDF;
//admin deficiencies pdf
export const generateDeficienciesPdf = (rowData) => {
  let content = `
    <div style="padding:20px; font-family: Arial;">
     <h2 style="text-align:center ;color: green;"> ${rowData.inst_name}</h2>
      <h2 style="text-align:center;">Deficiencies Report</h2> 
      <p><b>College Code:</b> ${rowData.coll_code}</p>
      <p><b>NOC Type:</b> ${rowData.noc_type || "-"}</p>

      <table style="width:100%; border-collapse: collapse; margin-top:20px;">
        <thead>
          <tr>
            <th style="border:1px solid black; padding:8px;">S.No</th>
            <th style="border:1px solid black; padding:8px;">Deficiency</th>
          </tr>
        </thead>
        <tbody>
  `;

  (rowData.def ||rowData.deficiencies|| []).forEach((d, index) => {
    content += `
      <tr>
        <td style="border:1px solid black; padding:8px; text-align:center;">
          ${index + 1}
        </td>
        <td style="border:1px solid black; padding:8px;">
          ${d.remarks || "-"}
        </td>
      </tr>
    `;
  });

  content += `
        </tbody>
      </table>
    </div>
  `;

  const element = document.createElement("div");
  element.innerHTML = content;

  html2pdf()
    .set({
      margin: 10,
      filename: "Deficiencies_Report.pdf",
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    })
    .from(element)
    .save();
};
//shifting def
export const shiftinggenerateDeficienciesPdf = (rowData) => {
  
  let content = `
    <div style="padding:20px; font-family: Arial;">
     <h2 style="text-align:center ;color: green;"> ${rowData.inst_name}</h2>
      <h2 style="text-align:center;">Deficiencies Report</h2> 
      <p><b>College Code:</b> ${rowData.coll_code}</p>
      <p><b>NOC Type:</b> ${rowData.noc_type || "-"}</p>

      <table style="width:100%; border-collapse: collapse; margin-top:20px;">
        <thead>
          <tr>
            <th style="border:1px solid black; padding:8px;">S.No</th>
            <th style="border:1px solid black; padding:8px;">Deficiency</th>
          </tr>
        </thead>
        <tbody>
  `;

  const deficiencies = rowData.def || [];
  
  
  if (deficiencies.length === 0) {
    content += `<tr><td colspan="2" style="border:1px solid black; padding:8px; text-align:center;">No deficiencies found</td></tr>`;
  } else {
    deficiencies.forEach((d, index) => {
      content += `
        <tr>
          <td style="border:1px solid black; padding:8px; text-align:center;">
            ${index + 1}
         </td>
          <td style="border:1px solid black; padding:8px;">
            ${d.remarks || "NO REMARKS FOUND"}
         </td>
       </tr>
      `;
    });
  }

  content += `
        </tbody>
      </table>
    </div>
  `;
  const element = document.createElement("div");
  element.innerHTML = content;

  html2pdf()
    .set({
      margin: 10,
      filename: "Deficiencies_Report.pdf",
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    })
    .from(element)
    .save();
};